import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useContext, useRef } from "react";
import { FOCUS_VISIBLE_OUTLINE } from "../../utils/css-helpers";
import { CheckIcon, MinusIcon } from "../icons";
import { ThemeProviderContext } from "../ThemeProvider";
import { GROUPED_ITEM_SPACING_CLASS_MAP } from "../utils/constants";
import { CheckboxContext } from "./CheckboxGroup";
export const Checkbox = ({ isChecked = false, isIndeterminate = false, onChange, label, hideLabel = false, subtext, hasError: explicitHasError, isDisabled = false, name, size: explicitSize = "medium", testId, className = "", tabIndex = 0, backgroundStyle = "transparent", }) => {
    var _a;
    const theme = useContext(ThemeProviderContext);
    const checkboxGroupContext = useContext(CheckboxContext);
    const inputRef = useRef(null);
    const size = (_a = checkboxGroupContext.size) !== null && _a !== void 0 ? _a : explicitSize;
    const hasError = explicitHasError !== null && explicitHasError !== void 0 ? explicitHasError : checkboxGroupContext.hasError;
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange({ event, value: event.target.checked });
    };
    const hasBackgroundFill = checkboxGroupContext.backgroundStyle === "filled" ||
        backgroundStyle === "filled";
    const inputClasses = [
        "appearance-none",
        "border",
        "rounded",
        "focus:outline-transparent",
        !isDisabled &&
            (isChecked || isIndeterminate) &&
            "bg-cta-primary-default dark:bg-general-indigo-primary-darkmode border-border-brand dark:border-border-brand-darkmode",
        isDisabled &&
            (isChecked || isIndeterminate) &&
            "bg-background-disabled dark:bg-background-disabled-darkmode",
        isDisabled &&
            !isChecked &&
            !isIndeterminate &&
            "bg-background-disabled dark:bg-background-disabled-darkmode",
        !isDisabled &&
            !isChecked &&
            !isIndeterminate &&
            hasBackgroundFill &&
            "bg-background-primary dark:bg-background-primary-darkmode",
        hasError &&
            !isDisabled &&
            !isChecked &&
            "border-border-critical dark:border-border-critical-darkmode",
        isDisabled && "border-border-subdued dark:border-border-subdued-darkmode",
        size === "medium" && ["w-2", "h-2", "min-w-2"],
        size === "large" && ["w-2.5", "h-2.5", "min-w-2.5"],
        "mt-0.25",
        "cursor-pointer",
        FOCUS_VISIBLE_OUTLINE,
    ];
    let Icon = null;
    if (isChecked) {
        Icon = CheckIcon;
    }
    else if (isIndeterminate) {
        Icon = MinusIcon;
    }
    const spacingClassName = GROUPED_ITEM_SPACING_CLASS_MAP[checkboxGroupContext.itemSpacing];
    return (_jsxs("label", { className: classNames([
            "relative",
            "inline-flex",
            "cursor-pointer",
            "text-text-primary",
            "dark:text-text-primary-darkmode",
            spacingClassName,
            className,
        ]), title: hideLabel ? label : "", children: [_jsx("input", { type: "checkbox", name: name, disabled: isDisabled, checked: isChecked, onChange: handleChange, className: classNames(inputClasses), ref: inputRef, [theme.testAttribute]: testId, tabIndex: tabIndex, "aria-label": hideLabel ? label : "" }), Icon && (_jsx("span", { className: isDisabled
                    ? "text-text-disabled dark:text-text-disabled-darkmode"
                    : "text-text-primary-inverse", children: _jsx(Icon, { className: "absolute left-0.25 top-0.5", size: size === "medium" ? "xs" : "sm" }) })), _jsxs("div", { className: "ml-1", children: [_jsx("div", { className: classNames(size === "medium" ? "text-md" : "text-lg", isDisabled && "text-text-disabled dark:text-text-disabled-darkmode"), children: !hideLabel && label }), subtext && (_jsx("div", { className: classNames(size === "medium" ? "text-sm" : "text-md", isDisabled
                            ? "text-text-disabled dark:text-text-disabled-darkmode"
                            : "text-text-subdued dark:text-text-subdued-darkmode"), children: subtext }))] })] }));
};
//# sourceMappingURL=Checkbox.js.map